import _ from 'lodash';
import { connect } from 'react-redux';
import { getStationData, getTankDailySales } from '../../modules/reports/monitoring';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {

	let tankDailySales = undefined;
	let tankDailyAverages = undefined;

	const stationId = parseInt(_.get(ownProps, ['match', 'params', 'stationId']), 10);
	const tankNumber = parseInt(_.get(ownProps, ['match', 'params', 'tankNumber']), 10);
	const stationTank = `${stationId}_${tankNumber}`;
	let stationData = undefined;

	if (state.reportsMonitoring.dataByStationTank[stationTank]) {
		stationData = state.reportsMonitoring.dataByStationTank[stationTank];
	}

	if (state.reportsMonitoring.tankDailySales) {
		tankDailySales = state.reportsMonitoring.tankDailySales;
	}

	if (state.reportsMonitoring.tankDailyAverages) {
		tankDailyAverages = state.reportsMonitoring.tankDailyAverages;
	}

	return {
		tankDailySales,
		tankDailyAverages,
		stationData,
		userMap : state.maps.user,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	getStationData,
	getTankDailySales,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
